var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBlok(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.503 6h8.872v8.825h-4.198l-4.674-4.293V6zm-3.006 20.416H2v-8.92h7.918l4.58 4.865v4.056zm3.006-4.055v4.056H30v-8.92h-7.823l-4.674 4.865zm-1.718-1.716v-4.198l-3.482-2.05v3.672l3.482 2.576zm-3.1-6.583 3.196 1.91 3.483-2.004-3.578-2.051-3.1 2.146zm6.964.335-3.435 2.051v4.198l3.434-2.099v-4.15zM14.64 6H5.483v8.825h4.484l4.675-4.293V6z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlok);
export default __webpack_public_path__ + "static/media/BLOK.80e60637ef3cdd3c292118fb416b1c31.svg";
export { ForwardRef as ReactComponent };